import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Star, ShieldCheck, Zap } from "lucide-react";
import HeroCarousel from "./HeroCarousel";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
      <div className="absolute inset-0 grain-bg opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 rounded-full border border-zinc-300 bg-white px-3 py-1">
            <span className="w-2 h-2 rounded-full bg-[#FFDF00] animate-pulse" />
            <span className="font-tactical text-[11px] uppercase tracking-[0.25em] text-zinc-700">
              AI Photo Quotes — Live in your area
            </span>
          </div>

          <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-zinc-900 mt-6 leading-[1.02]">
            Snap the mess.
            <br />
            <span className="text-[#0C2E2B]">We haul it, fix it,</span>
            <br />
            or build it. Today.
          </h1>

          <p className="mt-6 text-base sm:text-lg text-zinc-600 max-w-2xl leading-relaxed">
            Upload a photo of your junk pile, the hole in your wall, or that flat-pack you're avoiding —
            get an instant AI-generated quote in seconds. Same-day crews, honest pricing, zero surprises.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              data-testid="hero-cta-upload-photo-btn"
              onClick={() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" })}
              className="btn-kinetic rounded-md px-6 py-6 text-sm"
            >
              <Zap className="w-4 h-4 mr-2" /> Get Instant Photo Quote
            </Button>
            <Button
              variant="outline"
              data-testid="hero-cta-services-btn"
              onClick={() => document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" })}
              className="rounded-md px-6 py-6 text-sm font-bold border-zinc-300"
            >
              See All Services
            </Button>
          </div>

          <div className="mt-10 flex flex-wrap gap-6 items-center">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} className="w-4 h-4 fill-[#FFDF00] text-[#FFDF00]" />
                ))}
              </div>
              <span className="text-sm font-bold text-zinc-900">5.0</span>
              <span className="text-xs text-zinc-500">· 1,240+ jobs</span>
            </div>
            <div className="flex items-center gap-2 text-xs font-bold text-zinc-700">
              <ShieldCheck className="w-4 h-4 text-emerald-600" />
              $1M Liability Insured · Bonded
            </div>
            <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100 font-bold">
              BBB A+ Accredited
            </Badge>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <HeroCarousel />
          <div className="absolute -bottom-4 -left-4 w-24 h-24 stripe-dark rounded-xl -z-10" />
        </div>
      </div>
      <div className="tactical-divider mt-16 mx-auto max-w-7xl" />
    </section>
  );
}
